import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "sample-page",
    loadChildren: () =>
      import("../../components/sample-page/sample-page.module").then(
        (m) => m.SamplePageModule
      ),
  },
  {
    path: "nossos-sistemas",
    loadChildren: () =>
      import("../../components/nossos-sistemas/nossos-sistemas.module").then(
        (m) => m.NossosSistemasModule
      ),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("../../components/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "atendimentos",
    loadChildren: () =>
      import("../../components/atendimento/atendimento.module").then(
        (m) => m.AtendimentoModule
      ),
  },
  {
    path: "clientediagnostico",
    loadChildren: () =>
      import("../../components/informacaomunicipio/cliente-diagnostico.module").then(
        (m) => m.ClienteDiagnosticoModule
      ),
  },
  {
    path: "painelcidade",
    loadChildren: () =>
      import("../../components/painelcidade/painel-cidade.module").then(
        (m) => m.PainelCidadeModule
      ),
  },
  {
    path: "informacoes-das-cidades",
    loadChildren: () =>
      import("../../components/filtrocidades/filtrocidades.module").then(
        (m) => m.FiltrocidadesModule
      ),
  },
  {
    path: "gastos",
    loadChildren: () =>
      import("../../components/gasto/gasto.module").then((m) => m.GastoModule),
  },
  {
    path: "lancamentos",
    loadChildren: () =>
      import(
        "../../components/lancamentofinanceiro/lancamentofinanceiro.module"
      ).then((m) => m.LancamentoFinanceiroModule),
  },
  {
    path: "diatrabalhado",
    loadChildren: () =>
      import("../../components/diatrabalhado/diatrabalhado.module").then(
        (m) => m.DiaTrabalhadoModule
      ),
  },
  {
    path: "relatorio",
    loadChildren: () =>
      import("../../components/relatorio/relatorio.module").then(
        (m) => m.RelatorioModule
      ),
  },
  {
    path: "numerosuporte",
    loadChildren: () =>
      import("../../components/suporte/suporte.module").then(
        (m) => m.SuporteModule
      ),
  },
  {
    path: "motivo",
    loadChildren: () =>
      import("../../components/motivo/motivo.module").then(
        (m) => m.MotivoModule
      ),
  },
  {
    path: "sistema",
    loadChildren: () =>
      import("../../components/sistema/sistema.module").then(
        (m) => m.SistemaModule
      ),
  },
  {
    path: "cliente",
    loadChildren: () =>
      import("../../components/cliente/cliente.module").then(
        (m) => m.ClienteModule
      ),
  },
  {
    path: "solicitante",
    loadChildren: () =>
      import("../../components/solicitante/solicitante.module").then(
        (m) => m.SolicitanteModule
      ),
  },
  {
    path: "rotina",
    loadChildren: () =>
      import("../../components/rotina/rotina.module").then(
        (m) => m.RotinaModule
      ),
  },
  {
    path: "usuario",
    loadChildren: () =>
      import("../../components/usuario/usuario.module").then(
        (m) => m.UsuarioModule
      ),
  },
];
